var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnotation = function SvgAnnotation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6.75a2 2 0 0 1 2-2h10.5a2 2 0 0 1 2 2v8.5a2 2 0 0 1-2 2h-2.625l-2.625 2-2.625-2H6.75a2 2 0 0 1-2-2v-8.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAnnotation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00Ljc1IDYuNzVDNC43NSA1LjY0NTQzIDUuNjQ1NDMgNC43NSA2Ljc1IDQuNzVIMTcuMjVDMTguMzU0NiA0Ljc1IDE5LjI1IDUuNjQ1NDMgMTkuMjUgNi43NVYxNS4yNUMxOS4yNSAxNi4zNTQ2IDE4LjM1NDYgMTcuMjUgMTcuMjUgMTcuMjVIMTQuNjI1TDEyIDE5LjI1TDkuMzc1IDE3LjI1SDYuNzVDNS42NDU0MyAxNy4yNSA0Ljc1IDE2LjM1NDYgNC43NSAxNS4yNVY2Ljc1WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";